export default __webpack_public_path__ + "static/media/Opposites01_00.491cc77b.png";